module.exports = __webpack_public_path__ + "img/tit-four.5dde8f20.png";